import React from 'react'
import { withRouter } from 'react-router-dom'
import Header from './Header'
import { Sidebar } from './Sidebar'
import Container from 'react-bootstrap/Container'
import TEST from '../../enviroment/test.env'

class Wrap extends React.Component {
  state = {
    toggleSidebar: false,
    mobileSidebarOpen: false,
  }

  toggleSidebar = (e) => {
    e.preventDefault()
    this.setState({
      toggleSidebar: !this.state.toggleSidebar,
    })
  }

  toggleMobileSidebar = () => {
    this.setState((prev) => {
      const next = !prev.mobileSidebarOpen
      if (typeof document !== 'undefined') {
        document.body.style.overflow = next ? 'hidden' : ''
      }
      return { mobileSidebarOpen: next }
    })
  }

  closeMobileSidebar = () => {
    if (this.state.mobileSidebarOpen) {
      if (typeof document !== 'undefined') {
        document.body.style.overflow = ''
      }
      this.setState({ mobileSidebarOpen: false })
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location && this.props.location && prevProps.location.pathname !== this.props.location.pathname) {
      this.closeMobileSidebar()
    }
  }

  componentWillUnmount() {
    if (typeof document !== 'undefined') {
      document.body.style.overflow = ''
    }
  }

  render() {
    const menus = this.props.menus.filter((x) => x.tipoMenu == 0)
    const menuConfiguracao = this.props.menus.filter((x) => x.tipoMenu == 1)
    const isTest = window.location.origin.indexOf(TEST.REACT_APP_BASE_URL) != -1

    return (
      <div className='h-100'>
        <Header
          nome={this.props.nome}
          tipoUsuario={this.props.tipoUsuario}
          menus={menuConfiguracao}
          toggleSidebar={this.toggleSidebar}
          onToggleMobileSidebar={this.toggleMobileSidebar}
          isTest={isTest}
        />
        {this.state.mobileSidebarOpen && (
          <button
            type='button'
            className='sidebar-backdrop d-lg-none'
            aria-label='Fechar menu'
            onClick={this.closeMobileSidebar}
          />
        )}
        <Sidebar
          mesesAConfigurar={this.props.mesesAConfigurar}
          menus={menus}
          requestAcoes={this.props.requestAcoes}
          toggleSidebar={this.state.toggleSidebar}
          mobileSidebarOpen={this.state.mobileSidebarOpen}
          onCloseMobile={this.closeMobileSidebar}
        />
        <Container className={this.state.toggleSidebar ? 'wrap' : 'wrap has-sidebar'} fluid>
          {this.props.children}
        </Container>
      </div>
    )
  }
}

export default withRouter(Wrap)
